import { getNiceDate, isNumber, pluralize } from '@iotv/datamodel-core';
export const summariseObject = (ob, s) => {
    return Object.entries(ob).reduce((a, [k, v]) => {
        if (!(typeof v === 'object')) {
            let k2 = k, v2 = v;
            if (a)
                a += ', ';
            if (k.includes('Ms') && isNumber(v)) {
                v2 = getNiceDate(v);
                k2 = k.replace('Ms', '');
            }
            a += `${k2} set to ${v2}`;
        }
        else {
            a += summariseObject(v, a);
        }
        return a;
    }, s ?? '');
};
/**
 * Generates a human-readable string from the network coverage context
 */
export const summarizeContext = (context) => {
    const { Areas, Places, Networks, Gateways, parameters: Parameters, bounds: Bounds } = context;
    const areas = `${Areas.length} ${pluralize('area', Areas.length)}`;
    const places = `${Places.length} ${pluralize('place', Places.length)}`;
    const networks = `${Networks ? Networks.join(', ') : 'unknown networks'}`;
    const gateways = `${Gateways.length} gateways`;
    const parameters = `parameters: ${summariseObject(Parameters)}`;
    const bounds = `bounds: ${Bounds && summariseObject(Bounds)}`;
    return `${areas}, ${places}, from ${networks}, via ${gateways}, ${parameters}, ${bounds}`;
};
